import PurchaseHistoryRow from './PurchaseHistoryRow';

export default PurchaseHistoryRow;
